import { render, staticRenderFns } from "./CustomerCorporateProfile.vue?vue&type=template&id=7dcef81a&scoped=true"
import script from "./CustomerCorporateProfile.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateProfile.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateProfile.vue?vue&type=style&index=0&id=7dcef81a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcef81a",
  null
  
)

export default component.exports